<div class="flex items-end space-x-6">
    <div>
        <label for="price" class="block text-sm font-medium text-gray-500">Min</label>
        <div class="mt-1 relative rounded-md shadow-sm">
            <div class="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
                <span class="text-gray-500 sm:text-sm">
                    £
                </span>
            </div>
            <input
                type="number"
                name="min"
                id="min"
                [formControl]="minControl"
                class="focus:ring-primary-500 focus:border-primary-500 block w-full pl-5 pr-1 sm:text-sm border-gray-300 rounded-md"
                placeholder="0.00"
                min='0'
                aria-describedby="min-currency"
            />
        </div>
    </div>
    <div>
        <label for="price" class="block text-sm font-medium text-gray-500">Max</label>
        <div class="mt-1 relative rounded-md shadow-sm">
            <div class="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
                <span class="text-gray-500 sm:text-sm">
                    £
                </span>
            </div>
            <input
                type="number"
                name="max"
                id="max"
                [formControl]="maxControl"
                class="focus:ring-primary-500 focus:border-primary-500 block w-full pl-5 pr-1 sm:text-sm border-gray-300 rounded-md"
                placeholder="0.00"
                min='0'
                aria-describedby="max-currency"
            />
        </div>
    </div>
    <div>
        <button class="btn border-transparent"
                [disabled]='maxControl.pristine && minControl.pristine'
                [ngClass]="{
                    'bg-gray-200 hover:bg-gray-200 opacity-80': maxControl.pristine && minControl.pristine,
                    'bg-primary-600 hover:bg-primary-700 text-white': maxControl.dirty || minControl.dirty
                }"
                (click)="apply()">
            Apply
        </button>
    </div>
</div>
